"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CXTupleToDefaultPreferences = void 0;
const data_type_1 = require("../data/data-type");
const config_name_1 = require("./config-name");
const config_type_1 = require("./config-type");
/**
 * CXFamily and CXID form a combined unique identifier (CXTuple) that is an abstraction over the existing concept of
 * marketplace, which determines the ingress point of a customer. CXTuple is meant to encompass a broader set of site
 * experiences that are not restricted to just retail/marketplaces.
 * Reference: https://w.amazon.com/bin/view/INTech/CXFamilyCXId/
 *
 * Defines the Configurations available under the CXTuple To Default Preferences mapping table.
 */
class CXTupleToDefaultPreferences extends config_name_1.ConfigName {
    constructor(_name, _returnType) {
        super(_name, _returnType);
    }
    getConfigType() {
        return config_type_1.ConfigType.CX_TUPLE_TO_DEFAULT_PREFERENCES;
    }
}
exports.CXTupleToDefaultPreferences = CXTupleToDefaultPreferences;
/**
 * Default currency is stored in String format.
 */
CXTupleToDefaultPreferences.DEFAULT_CURRENCY = new CXTupleToDefaultPreferences('default_currency', data_type_1.DataType.STRING);
/**
 * Default language is stored in String format.
 */
CXTupleToDefaultPreferences.DEFAULT_LANGUAGE = new CXTupleToDefaultPreferences('default_language', data_type_1.DataType.STRING);
//# sourceMappingURL=cx-tuple-to-default-preferences.js.map